import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from '@/store/context';
import { useClientStore } from '@/store/client';
import { usePanierStore } from "@/store/panier";
import dateUtil from "@/utils/date.js";
import { useMagasinStore } from "@/store/magasin";
import { useGtm } from '@gtm-support/vue-gtm';
import { useRoute } from 'vue-router';

export const useTransactionConfirmationTracking = () => {
  const gtm = useGtm();
  const route = useRoute()
  const contextStore = useContextStore();
  const magasinStore = useMagasinStore();
  const clientStore = useClientStore();
  const panierStore = usePanierStore();

  const { ligneClonePanier } = storeToRefs(panierStore);
  const { layout } = storeToRefs(contextStore);
  const { id: magasinId } = storeToRefs(magasinStore);
  const { clientStatut, ordersNumber, lastOrderDate, abonnements } = storeToRefs(clientStore);

  const abonnementDuration = computed(() => {
    if (abonnements.value === null) {
      return null;
    } else {
      const abonnement = abonnements.value.find(
        (abo) => abo.attributes.magasin_id === magasinId.value
      )
      if (abonnement && abonnement.attributes && dateUtil.isToday(abonnement.attributes.date_debut)) {
        return abonnement.attributes.duree
      }
      return null
    }
  })

  const trackTransactionConfirmation = (order) => {
    let orderfees = 0;
    let discountCode = "";
    let shippnigMode = "";
    let revenueWithoutDiscount = 0;
    let totalDiscountAmount = 0;
    let products = [];
    let totalAmount = 0;
    let withdrawlDate = "";
    let nbArticles = 0;
    let modePaiement = "";
    let hasEurocora = false;
    let isAlias = false;
    if (order && order.data && order.data.attributes) {
      const attributes = order.data.attributes;
      modePaiement = attributes.code_paiement;
      withdrawlDate = attributes.date_de_retrait;
      if (attributes.frais && attributes.frais.length > 0) {
        const fees = attributes.frais;
        for (let i = 0; i < fees.length; i++) {
          if (parseFloat(fees[i].valeur)) { orderfees += parseFloat(fees[i].valeur) }
        }
      }
      if (attributes.reductions && attributes.reductions.length) {
        discountCode = attributes.reductions ? attributes.reductions.find(reduc => reduc.type === "code_promo") : "";
      }
      if (attributes.montant_total_remise || attributes.reductions) {
        totalDiscountAmount = parseFloat(attributes.montant_total_remise);
        if (attributes.reductions && attributes.reductions.length > 0) {
          for (let i = 0; i < attributes.reductions.length; i++) {
            totalDiscountAmount += parseFloat(attributes.reductions[i].valeur)
          }
        }
      }
      totalAmount = parseFloat(attributes.montant_total_ttc);
      revenueWithoutDiscount = totalAmount + totalDiscountAmount
      shippnigMode = attributes.code_type_commande;
      hasEurocora = attributes.montant_reservation_eurocora > 0;
      isAlias = attributes.has_alias_paiement
      products = (ligneClonePanier.value ? ligneClonePanier.value : attributes.lignes_commande.data).map(productItem => {
        const product = (ligneClonePanier.value ? productItem : productItem.attributes)

        const quantite = parseInt(product.quantite);
        nbArticles += quantite;
        const item = {
          name: product.designation,
          id: product.produit_id || product.id,
          price: product.prix_unitaire || product.prix,
          brand: product.brand || product.marque,
          category: product.category_path,
          variant: product.axes_variants || "",
          quantity: quantite,
          dimension10: product.review_rate || "",
          dimension11: "",
          dimension12: product.nb_photo || product.nombre_images,
          dimension13: product.reviews_count || "",
          metric3: product.taux_tva,
          metric4: product.prix_ht,
          metric5: product.discount_amount || "",
          context: product.context || ""
        }
        return item
      })
    }
    const pushObject = {
      event: trackingCodes.PURCHASEOK,
      categoryGA: trackingCodes.CATEGORYGA.ecommerce,
      actionGA: trackingCodes.PURCHASEOK,
      statusClient: clientStatut.value,
      lastOrderDate: lastOrderDate.value,
      numberOrder: ordersNumber.value,
      modeCommande: shippnigMode,
      hasEurocora,
      isAlias,
      modePaiement,
      panierNombreArticles: nbArticles,
      abonnementAuPanier: abonnementDuration.value ? abonnementDuration.value + "mois" : "aucun",
      nonInteraction: false,
      withdrawlDate,
      ecommerce: {
        purchase: {
          actionField: {
            id: route.params.id,
            revenue: totalAmount.toFixed(2),
            shipping: orderfees,
            coupon: discountCode || ""
          },
          products
        }
      }
    }

    pushObject.totalDiscount = totalDiscountAmount;
    pushObject.revenueWithoutDiscount = parseFloat(revenueWithoutDiscount.toFixed(2));
    pushObject.sitetype = layout.value === LayoutTypes.default ? 'd' : 'm'
    try {
      gtm.trackEvent(pushObject)
    } catch { }
  }

  return { trackTransactionConfirmation }
}
